import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.3334 8.99999C17.3334 4.39762 13.6025 0.666656 9.00008 0.666656C4.39771 0.666656 0.666748 4.39762 0.666748 8.99999C0.666748 13.6024 4.39771 17.3333 9.00008 17.3333C13.6025 17.3333 17.3334 13.6024 17.3334 8.99999ZM1.91675 8.99999C1.91675 5.08797 5.08806 1.91666 9.00008 1.91666C12.9121 1.91666 16.0834 5.08797 16.0834 8.99999C16.0834 12.912 12.9121 16.0833 9.00008 16.0833C5.08806 16.0833 1.91675 12.912 1.91675 8.99999ZM9.00008 11.7083C9.31649 11.7083 9.57799 11.9435 9.61938 12.2485L9.62508 12.3333V13.1667C9.62508 13.5118 9.34526 13.7917 9.00008 13.7917C8.68367 13.7917 8.42217 13.5565 8.38079 13.2515L8.37508 13.1667V12.3333C8.37508 11.9881 8.6549 11.7083 9.00008 11.7083ZM9.61938 4.74851C9.57799 4.44345 9.31649 4.20832 9.00008 4.20832C8.6549 4.20832 8.37508 4.48814 8.37508 4.83332V9.83332L8.38079 9.91813C8.42217 10.2232 8.68367 10.4583 9.00008 10.4583C9.34526 10.4583 9.62508 10.1785 9.62508 9.83332V4.83332L9.61938 4.74851Z",
      fill: "#FF5537"
    }, null, -1)
  ]))]))
}
export default { render: render }